import C_Ships from "../const/C_Ships"

/**
 * Names of sounds
 */
class C_Snd
{
    constructor()
    {
        this.BTN_DOWN = "btn";

        this.WEAPON_SHOOT = "weapon_shoot";
        this.ENEMY_SHOOT = "ship_hit";
        this.DESTROY = {};
        this.DESTROY[C_Ships.ENEMY_SHIP] = "ship_explode_1";
        this.DESTROY[C_Ships.ROCK] = "ship_explode_2";
        this.DESTROY[C_Ships.CRATE] = "ship_explode_2";
        this.DESTROY[C_Ships.DEBRIS] = "ship_explode_3";
        this.DESTROY[C_Ships.POD] = "ship_explode_3";
        this.DESTROY[C_Ships.FLARE] = "ship_explode_4";
        this.SHIELD_HIT = "shield_hit";
        this.FLY_BY_SPACECRAFT_1 = "near_spacecraft_1";
        this.FLY_BY_SPACECRAFT_2 = "near_spacecraft_2";
        this.FLY_BY_SPACECRAFT_3 = "near_spacecraft_3";
        this.FLY_BY_SPACECRAFT_4 = "near_spacecraft_4";
        this.FLY_BY_SPACECRAFT_5 = "near_spacecraft_5";
        this.RANDOM_SPACE_SOUNDS = ["reverse_suction_01", "reverse_suction_02"];

        // Musics
        this.MAIN_THEME = "main_theme_music";
        this.MENU_THEME = "menu_theme_music";
    }

}

export default (new C_Snd);